import { useState } from 'react';
import FormSelector from './FormSelector';
import { FORM_COMPONENTS, BEAM_FORM_COMPONENTS } from '../Constants/Constants';
import { canManageSniperCsm, isBeamUser, SNIPER_CSM_FORMS } from '../Utils/HelperFunctions';

const Dashboard = () => {
  const [selectedForm, setSelectedForm] = useState('');
  const components = isBeamUser() ? BEAM_FORM_COMPONENTS : FORM_COMPONENTS;
  const isHidden = SNIPER_CSM_FORMS.includes(selectedForm) && !canManageSniperCsm();

  return (
    <div className='csm-container'>
      <div className='box w-full flex flex-col gap-4 pb-10'>
        <h1 className='my-5 text-center text-3xl font-semibold '>CSM-Dashboard</h1>
        <FormSelector onChange={setSelectedForm} />
        <div className='w-full'>{isHidden ? null : (components[selectedForm] ?? null)}</div>
      </div>
    </div>
  );
};

export default Dashboard;
